import { Toaster } from 'react-hot-toast';
import IconCheck from '@/images/icons/icon_check.svg?react';
import IconError from '@/images/icons/icon_error.svg?react';

export const EqutumToast = () => {
  return (
    <Toaster
      position="top-center"
      reverseOrder={false}
      toastOptions={{
        success: { className: 'border border-positive-tint ', icon: null },
        error: { className: 'border border-negative-tint ', icon: null },
      }}
    />
  );
};

export const PositiveToast = ({ message }: { message: string }) => {
  return (
    <div className="flex items-center gap-2.5">
      <div className="bg-positive my-auto flex h-6 min-h-[24px] w-6 items-center justify-center gap-2.5 self-stretch rounded-[100px]">
        <IconCheck />
      </div>
      <div className="text-positive my-auto flex-1 shrink basis-0 self-stretch text-sm leading-snug font-medium tracking-wide whitespace-pre-wrap">
        {message}
      </div>
    </div>
  );
};

export const NegativeToast = ({ message }: { message: string }) => {
  return (
    <div className="flex items-center gap-2.5">
      <div className="bg-negative text-negative my-auto flex h-6 min-h-[24px] w-6 items-center justify-center gap-2.5 self-stretch rounded-[100px]">
        <IconError />
      </div>
      <div className="text-negative my-auto flex-1 shrink basis-0 self-stretch text-sm leading-snug font-medium tracking-wide">
        {message}
      </div>
    </div>
  );
};
